export default {
  Title: 'Registre su método de MFA.',
  SubTitle:
    'La autenticación multifactor es requerida para iniciar sesión en la Solución de Identidad Digital de Texas y cualquiera de sus aplicaciones integradas. Si tiene preguntas o inquietudes, por favor contacte al administrador de su organización.',
  InstructionsLink: '¿Necesita ayuda? Acceda a la Guía de inscripción de TDIS desde la página web del DIR.',
  PhoneTitle: 'Por favor ingrese su número de teléfono.',
  PhoneSubTitle: 'Enviaremos un código de verificación a este número.',
  AuthenticatorTitle: 'Configure su aplicación de autenticación.',
  AuthenticatorSubTitle: 'Escanee el código QR con su aplicación de autenticación para completar el registro.',
  PasskeyTitle: 'Registre su clave de acceso.',
  PasskeySubTitle: 'Siga las indicaciones para registrar su clave de seguridad o Windows Hello.',
};
